'use client';

import { BaseTranslations } from '../../../../baseTranslations';
import { useCmsClientContext } from '../../../../utils/cmsPageContext';
import { getFulfilmentPath } from '../../../../utils/tiAttributes';
import { getClientTranslations } from '../../../../utils/translations/getClientTranslations';
import { resolveTiCtaLabel } from '../../../ApplyCta/resolveTiCtaLabel';
import { ProductDetailsProps } from '../../ProductDetails';
import { ProductDetailsStickyFooter } from './ProductDetailsStickyFooter';

/**
 * The shared sticky footer with the standardised TI Apply label, the same one the TI nav's Apply
 * uses. Modal only — see `buildTravelInsuranceSections`.
 */
export const ProductDetailsStickyFooterTi: React.FC<ProductDetailsProps> = (
  props,
) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);
  const ctaLabel = resolveTiCtaLabel({
    brand: context.brand,
    staticText,
    fulfilmentPath: getFulfilmentPath(props.product),
    callToAction: props.product?.call_to_action,
  });

  return <ProductDetailsStickyFooter {...props} ctaLabel={ctaLabel} />;
};
